import React from 'react'
import './index.css'
import BasicButton from '../basicButton';
import { FaGasPump } from "react-icons/fa";
import { TbSteeringWheel } from "react-icons/tb";
import { BsPeopleFill } from "react-icons/bs";
import carDetailImg from '../../Assets/images/carDetailImg.webp'
import { useFormatMoney } from '../../Config/utils/formatCurrency'

const VehicleCard = (cardData) => {
    const { cardData: details, onRentNow } = cardData;
    const formatMoney = useFormatMoney();

    const handleRentNow = (e) => {
        e.stopPropagation();
        if (onRentNow) {
            onRentNow();
        }
    };

    const handleImageError = (e) => {
        if (e.currentTarget.dataset.fallbackApplied === 'true') return
        e.currentTarget.dataset.fallbackApplied = 'true'
        e.currentTarget.src = carDetailImg
    };
    
    return (
        <div className='flex flex-col items-start p-3 gap-3 cursor-pointer bg-[#FFFFFF] card-shadow'>
            <h3 className='font-semibold'>{details.title}</h3>
            <p className='break-all text-[#90A3BF]'>{details.desc}</p>
            <div className='relative h-[140px] w-full overflow-hidden'>
                <img
                    src={details.image || carDetailImg}
                    className='h-full w-full object-cover'
                    alt={details.title}
                    loading='lazy'
                    onError={handleImageError}
                />
            </div>
            <div className='w-full flex items-center justify-between'>
            <div className='flex items-center gap-2 text-[#90A3BF]'>
                    <FaGasPump />
                    <span>{details.litre} L</span>
                </div>
                <div className='flex items-center gap-2 text-[#90A3BF]'>
                    <TbSteeringWheel />
                    <span>{details.type}</span>
                </div>
                <div className='flex items-center gap-2 text-[#90A3BF]'>
                    <BsPeopleFill />
                    <span>{details.count} people</span>
                </div>
            </div>
            <div className='flex justify-between items-center w-full gap-2'>
                <span className='text-[#2ED1E1] font-bold text-base whitespace-nowrap shrink-0'>{formatMoney(details.price, { style: 'symbol' })}/ <span className='text-[#90A3BF]'>day</span></span>
                <p className='py-2 px-3 text-black bg-[#FFDA32] cursor-pointer shrink-0' onClick={handleRentNow}>Rent Now</p>
            </div>
        </div>
    )
}

export default VehicleCard